import React from "react";
import { CheckCircle2, FileText } from "lucide-react";

import { Input } from "@/components/ui/input";
import { InputDecimal } from "@/components/ui/input-decimal";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

import CampoClassificacao from "./CampoClassificacao";
import CampoFornecedor from "./CampoFornecedor";

export function Cartao({ titulo, icone: Icone, children, acao, e2e }) {
  return (
    <section className="bg-card rounded-2xl border p-5 sm:p-6" data-e2e={e2e}>
      <div className="flex items-center gap-2 mb-4">
        <Icone className="w-5 h-5 text-primary" />
        <h2 className="text-base font-bold">{titulo}</h2>
        {acao && <div className="ml-auto">{acao}</div>}
      </div>
      {children}
    </section>
  );
}

// Nome, classificação, fornecedor, valor, vencimento e "já foi paga".
export default function SecaoDados({ d }) {
  const { form, definir } = d;
  return (
    <Cartao titulo="Dados da despesa" icone={FileText} e2e="secao-dados">
      <div className="space-y-4">
        <div>
          <Label>Nome da despesa *</Label>
          <Input value={form.name} onChange={(e) => definir("name", e.target.value)} placeholder="Ex: Conta de Luz, Aluguel..."
            className="mt-1" autoFocus data-e2e="campo-nome" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label>Classificação</Label>
            <div className="mt-1">
              <CampoClassificacao valor={form.classificationId} onChange={(v) => definir("classificationId", v)}
                classificacoes={d.classificacoes} aoCriar={d.novaClassificacao} />
            </div>
          </div>
          <div>
            <Label>Fornecedor</Label>
            <div className="mt-1"><CampoFornecedor valor={form.supplier} onChange={(v) => definir("supplier", v)} fornecedores={d.fornecedores} /></div>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <Label>{form.installments && parseInt(form.installments, 10) > 1 ? "Valor de cada parcela *" : "Valor *"}</Label>
            <div className="mt-1 flex items-center gap-2">
              <span className="text-muted-foreground text-sm">R$</span>
              <div className="flex-1"><InputDecimal decimals={2} value={form.value} onChange={(v) => definir("value", v)} data-e2e="campo-valor" /></div>
            </div>
          </div>
          <div>
            <Label>Data de vencimento *</Label>
            <Input type="date" value={form.dueDate} onChange={(e) => definir("dueDate", e.target.value)} className="mt-1" data-e2e="campo-vencimento" />
          </div>
        </div>
        <label className="flex items-center justify-between p-3 bg-muted rounded-lg cursor-pointer">
          <span className="flex items-center gap-2 text-sm font-medium"><CheckCircle2 className="w-4 h-4 text-green-600" />Despesa já foi paga</span>
          <Switch checked={form.isPaid} onCheckedChange={(v) => definir("isPaid", v)} data-e2e="campo-paga" />
        </label>
      </div>
    </Cartao>
  );
}
